import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PatientsService } from 'apps/idl/src/modules/patients/services/patients.service';
import { DateHelper, StringHelper } from 'apps/idl/src/helpers';
import { ETimetablePattern } from 'apps/idl/src/model';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { PanneauService } from 'apps/idl/src/anakin/features/shared/services/panneau.service';
import { PatientHelper } from 'apps/idl/src/anakin/features/shared/helpers/patient.helper';
@Component({
  templateUrl: './panneau-dossier-patient-succes.component.html',
  styleUrls: ['./panneau-dossier-patient-succes.component.scss']
})
export class PanneauDossierPatientSuccesComponent implements OnInit{

  @Input() public patient: IPatient;
  @Input() public nouveauPatient: boolean = false;
  public birthDateString: string;
  public gender: string;
  public genderColor: string;
  public nameString: string;

  constructor(
    private svcPanneau: PanneauService,
    private router: Router,
    private svcPatients: PatientsService
  ) { }

  ngOnInit(): void {
    this.nameString = PatientHelper.getFullNamePatient(this.patient) + (this.patient.firstName ? ' ' + StringHelper.toTitleCase(PatientHelper.getPatientFirstName(this.patient)) : '')
    this.gender = this.svcPatients.getPatientGender(this.patient.gender);
    this.genderColor = this.svcPatients.setGenderColor(this.patient);
    this.birthDateString = DateHelper.transform(this.patient.birthDate, ETimetablePattern.dd_MM_yyyy_slash);
  }

  public openDossierPatient(): void {
    this.svcPanneau.close();
    this.router.navigate(["/patients", this.patient._id], { state: { tabSelected: "Informations" } });
  }
}